import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

// Pages
import HomePage from "./pages/HomePage";
import FormationsPage from "./pages/FormationsPage";
import FormateursPage from "./pages/FormateursPage";
import TunnelVentePage from "./pages/TunnelVentePage";
import EspacePedagogiquePage from "./pages/EspacePedagogiquePage";
import JeuInteractifPage from "./pages/JeuInteractifPage";
import DevisPage from "./pages/DevisPage";
import OutilsIAPage from "./pages/OutilsIAPage";
import GalilePage from "./pages/GalilePage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import ArticlePage from "./pages/ArticlePage";
import CommandCenterPage from "./pages/CommandCenterPage";
import BlogPage from "./pages/BlogPage";
import BlogArticlePage from "./pages/BlogArticlePage";
import FunnelFormationPage from "./pages/FunnelFormationPage";
import RetexViewPage from "./pages/RetexViewPage";

// SEO Pages
import OutilsGoogleAIPage from "./pages/seo/OutilsGoogleAIPage";
import OutilsIAEntreprisePage from "./pages/seo/OutilsIAEntreprisePage";
import FormationIAMetierPage from "./pages/seo/FormationIAMetierPage";
import FormationChatGPTEntreprisePage from "./pages/seo/FormationChatGPTEntreprisePage";

// Components
import LucieChatbot from "./components/LucieChatbot";

function App() {
  return (
    <HelmetProvider>
      <div className="min-h-screen bg-[#050505]">
        <div className="grain-overlay" />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/formations" element={<FormationsPage />} />
            <Route path="/formateurs" element={<FormateursPage />} />
            <Route path="/tunnel" element={<TunnelVentePage />} />
            <Route path="/espace-pedagogique" element={<EspacePedagogiquePage />} />
            <Route path="/actualite/:articleId" element={<ArticlePage />} />
            <Route path="/jeu" element={<JeuInteractifPage />} />
            <Route path="/jeu/:companyCode" element={<JeuInteractifPage />} />
            <Route path="/devis/:quoteId" element={<DevisPage />} />
            <Route path="/outils-ia" element={<OutilsIAPage />} />
            <Route path="/galile" element={<GalilePage />} />
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            {/* Blog SEO - Powered by Robot Speed */}
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogArticlePage />} />
            {/* Funnel Formation - Landing Page Ads */}
            <Route path="/formation-ia" element={<FunnelFormationPage />} />
            <Route path="/formation" element={<FunnelFormationPage />} />
            
            {/* SEO Pages - Formation Intelligence Artificielle */}
            <Route path="/formation-google-ai" element={<OutilsGoogleAIPage />} />
            <Route path="/outils-ia-entreprise" element={<OutilsIAEntreprisePage />} />
            <Route path="/formation-ia-metier" element={<FormationIAMetierPage />} />
            <Route path="/formation-chatgpt-entreprise" element={<FormationChatGPTEntreprisePage />} />
            
            {/* Secret Command Center - Triple click on logo to access */}
            <Route path="/lea-command" element={<CommandCenterPage />} />
            
            {/* RETEX View Page - Public access with audio player */}
            <Route path="/retex/:retexId" element={<RetexViewPage />} />
          </Routes>
          
          {/* Lucie Chatbot - appears on all pages */}
          <LucieChatbot />
        </BrowserRouter>
        <Toaster 
          position="top-right" 
          theme="dark"
          toastOptions={{
            style: {
              background: '#0F0F10',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#fff'
            }
          }}
        />
      </div>
    </HelmetProvider>
  );
}

export default App;
